import { render } from "./SupportVideoPlayer.vue?vue&type=template&id=b07145fc&scoped=true&ts=true"
import script from "./SupportVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./SupportVideoPlayer.vue?vue&type=script&lang=ts"

import "./SupportVideoPlayer.vue?vue&type=style&index=0&id=b07145fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07145fc"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QTooltip,QSpinner});
